import router from "./router";
import store from "./store";
import axios from "axios";

let isRefreshing = false;
let failedQueue = [];

const processQueue = error => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve();
    }
  });
  failedQueue = [];
};

const fetchRefreshToken = () => {
  return axios.get("refresh-token");
};

export default error => {
  const originalRequest = error.config;

  if (error.response.status === 401 && !originalRequest._retry) {
    if (isRefreshing) {
      return new Promise(function(resolve, reject) {
        failedQueue.push({ resolve, reject });
      })
        .then(() => {
          originalRequest.baseURL = "";
          return axios(originalRequest);
        })
        .catch(err => {
          return Promise.reject(err);
        });
    }

    originalRequest._retry = true;
    isRefreshing = true;

    return new Promise(function(resolve, reject) {
      fetchRefreshToken()
        .then(() => {
          processQueue(null);
          originalRequest.baseURL = "";
          resolve(axios(originalRequest));
        })
        .catch(err => {
          processQueue(err);
          store.dispatch("logout");
          router.push("/login");
          reject(err);
        })
        .then(() => {
          isRefreshing = false;
        });
    });
  }

  return Promise.reject(error);
};
